import React from "react";

// reactstrap components
import {Col, Container, Row,} from "reactstrap";

// core components
import DefaultFooter from "components/Footers/DefaultFooter.js";
import IndexNavbar from "components/Navbars/IndexNavbar";
import LandingPageHeader from "components/Headers/LandingPageHeader";

function CorporatePage() {

  React.useEffect(() => {
    document.body.classList.add("profile-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    return function cleanup() {
      document.body.classList.remove("profile-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  return (
    <>
      <IndexNavbar />
      <div className="wrapper">
        <LandingPageHeader />
        <div className="section">
          <Container>
            <h3 className="title">Corporate Engagement</h3>
            <Row>
              <Col md="12">
                <div class="iframe-embed-wrapper iframe-embed-responsive-16by9">
                  <iframe class="iframe-embed" frameborder="0" width={"100%"} src="https:&#x2F;&#x2F;www.canva.com&#x2F;design&#x2F;DAERT02vkK4&#x2F;view?embed">
                  </iframe>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <DefaultFooter />
      </div>
    </>
  );
}

export default CorporatePage;
